import type { OnyxTableViewIcon } from './interfaces';

export const ONYX_TABLE_VIEW_DEFAULT_ICON: OnyxTableViewIcon = 'list-outlined';

export const ONYX_TABLE_BATCH_ACTIONS_HIDE_DURATION = 500;
